import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import Footer from '../../components/Footer/Footer'
import Seattle from '../../components/Seattle/Seattle'

const Seattlepage = () => {
    return (
        <div>
        <Navbar/>
        <Seattle/>


        <Footer/>

        </div>
    )
}

export default Seattlepage